module.exports = __webpack_public_path__ + "img/dog4.8f451bbc.png";